import React from "react";
import BannerSection from "../../QuinceneraPage/qbannerSection";
import WelcomeSection from "../welcomeSection";
import ServiceSection from "../../QuinceneraPage/serviceSection";
import PreferredVendorsSection from "../../QuinceneraPage/preferredVendorsSection";
import PackagesSection from "../../QuinceneraPage/PackagesSection";
import VenueHighlightSection from "../../HomePage/VenueHighlightSection";
import Gallery from "../../QuinceneraPage/gallery";
import VenueHighlights from "../../QuinceneraPage/venueHighlights";
import Amenities from "../../QuinceneraPage/amenities";
import TestimonialSection from "../../HomePage/TestimonialSection";
import VideosSection from "../../HomePage/VideosSection";
import BlogsSection from "../../HomePage/BlogsSection";
import BdyEventips from "./bdyEventTips";
import GraduationEventTips from "./graduationEventTips";
import OthersEventTips from "./othersEventTips";

export const others = () => {
  return (
    <>
      <BannerSection id={19} />
      <WelcomeSection id={19} titleName={"Other Events"} />

      <ServiceSection id={19} />
      <PreferredVendorsSection id={19} />
      <PackagesSection id={19} />
      <VenueHighlightSection />
      <Gallery id={19} titleName={"Other Events"} />
      <VenueHighlights id={19} />
      <Amenities id={19} />
      <TestimonialSection id={19} />
      <VideosSection id={19} />
      <BlogsSection id={19} />
      <OthersEventTips id={19} />
    </>
  );
};
